import { temporarilyNotSupport } from '../../utils'

export const setPageInfo = /* @__PURE__ */ temporarilyNotSupport('setPageInfo')

// 百度小程序 AI 相关
export const ocrIdCard = /* @__PURE__ */ temporarilyNotSupport('ocrIdCard')
export const ocrBankCard = /* @__PURE__ */ temporarilyNotSupport('ocrBankCard')
export const ocrDrivingLicense = /* @__PURE__ */ temporarilyNotSupport('ocrDrivingLicense')
export const ocrVehicleLicense = /* @__PURE__ */ temporarilyNotSupport('ocrVehicleLicense')
export const textReview = /* @__PURE__ */ temporarilyNotSupport('textReview')
export const textToAudio = /* @__PURE__ */ temporarilyNotSupport('textToAudio')
export const imageAudit = /* @__PURE__ */ temporarilyNotSupport('imageAudit')
export const advancedGeneralIdentify = /* @__PURE__ */ temporarilyNotSupport('advancedGeneralIdentify')
export const objectDetectIdentify = /* @__PURE__ */ temporarilyNotSupport('objectDetectIdentify')
export const carClassify = /* @__PURE__ */ temporarilyNotSupport('carClassify')
export const dishClassify = /* @__PURE__ */ temporarilyNotSupport('dishClassify')
export const logoClassify = /* @__PURE__ */ temporarilyNotSupport('logoClassify')
export const animalClassify = /* @__PURE__ */ temporarilyNotSupport('animalClassify')
export const plantClassify = /* @__PURE__ */ temporarilyNotSupport('plantClassify')

// 用户信息
export const getSwanId = /* @__PURE__ */ temporarilyNotSupport('getSwanId')

// 百度收银台支付
export const requestPolymerPayment = /* @__PURE__ */ temporarilyNotSupport('requestPolymerPayment')

// 打开小程序
export const navigateToSmartGameProgram = /* @__PURE__ */ temporarilyNotSupport('navigateToSmartGameProgram')
export const navigateToSmartProgram = /* @__PURE__ */ temporarilyNotSupport('navigateToSmartProgram')
export const navigateBackSmartProgram = /* @__PURE__ */ temporarilyNotSupport('navigateBackSmartProgram')
export const preloadSubPackage = /* @__PURE__ */ temporarilyNotSupport('preloadSubPackage')
